<template>
  <v-col :data-hint="$t('message.introJS.videoPageOptions.pandaIa')">
    <div class="d-flex flex-row align-center mb-2">
      <h3 class="">
        {{ $t('message.pages.video.playerOptionTitles.pandaIa') }}
      </h3>
      <span class="ml-2">
        <span class="mb-0 newItemText font-weight-medium">{{
          $t('message.pages.video.new')
        }}</span>
      </span>
      <credits-info
        :class="{ 'd-none': hiddeActiveBtn }"
        :activationPrice="aiWorkFlowCreditsBalance.aiWorkFlowPrice"
      ></credits-info>
      <v-tooltip top v-if="video.status === 'CONVERTING' || !video.playable">
        <template v-slot:activator="{ on, attrs }">
          <div :v-on="on" :v-bind="attrs">
            <v-btn
              :class="{ 'd-none': hiddeActiveBtn }"
              class="ml-auto primary active-btn mr-8"
              @click="openAiWorkFlowChargeModal"
              :disabled="
                hasError || video.status === 'CONVERTING' || !video.playable
              "
              >{{ $t('message.pages.video.ative') }}
            </v-btn>
          </div>
        </template>
        <span>aaa</span>
      </v-tooltip>
      <v-btn
        v-else
        :class="{ 'd-none': hiddeActiveBtn }"
        class="ml-auto primary active-btn mr-8"
        @click="openAiWorkFlowChargeModal"
        >{{ $t('message.pages.video.ative') }}
      </v-btn>
    </div>
    <v-card
      flat
      tile
      class="d-flex flex-column text-left"
      :disabled="!aiWorkFlowCreated"
    >
      <!-- mind map -->
      <v-btn
        v-if="!video.hasOwnProperty('video_source')"
        class="btn"
        x-large
        @click="handleSelectOption('mindMap')"
        text
        :disabled="isLoading.mindmap || hasError"
      >
        <span class="d-flex">
          <div class="container-list-icon">
            <simple-svg
              :src="require('@/assets/mindMap.svg')"
              width="24px"
              height="24px"
              fill-class-name="fill-color"
              :fill="$vuetify.theme.dark ? 'white' : 'black'"
            />
          </div>
          <p class="optionsText">
            {{ $t('message.ai.mindmap.mindmap') }}
            <sup class="newItemText">BETA</sup>
          </p>
        </span>
        <div>
          <v-progress-circular
            v-if="isLoading.mindmap && !hasError"
            size="22"
            width="2"
            indeterminate
            color="primary"
          />
          <v-icon>mdi-chevron-right</v-icon>
        </div>
      </v-btn>

      <!-- quiz -->
      <v-btn
        v-if="!video.hasOwnProperty('video_source')"
        class="btn"
        x-large
        @click="handleSelectOption('quiz')"
        text
        :disabled="isLoading.questions || hasError"
      >
        <span class="d-flex">
          <v-icon>mdi-help-box-multiple</v-icon>
          <p class="optionsText">Quiz <sup class="newItemText">BETA</sup></p>
        </span>
        <div>
          <v-progress-circular
            v-if="isLoading.questions && !hasError"
            size="22"
            width="2"
            indeterminate
            color="primary"
          />
          <v-icon>mdi-chevron-right</v-icon>
        </div>
      </v-btn>

      <!-- ebook -->
      <v-btn
        v-if="!video.hasOwnProperty('video_source')"
        class="btn"
        x-large
        @click="handleSelectOption('ebook')"
        text
        :disabled="isLoading.abstract || hasError"
      >
        <span class="d-flex">
          <div class="container-list-icon">
            <simple-svg
              :src="require('@/assets/ebook.svg')"
              fill-class-name="fill-color"
              :fill="$vuetify.theme.dark ? 'white' : 'black'"
              width="24px"
              height="24px"
            />
          </div>
          <p class="optionsText">
            {{ $i18next.t('message.ai.abstract.ebook') }}
            <sup class="newItemText">BETA</sup>
          </p>
        </span>
        <div>
          <v-progress-circular
            v-if="isLoading.abstract && !hasError"
            size="22"
            width="2"
            indeterminate
            color="primary"
          />
          <v-icon>mdi-chevron-right</v-icon>
        </div>
      </v-btn>
    </v-card>
    <ai-workflow-charge-modal
      :openModal="isModalOpen"
      :aiWorkFlowCreditsBalance="aiWorkFlowCreditsBalance"
      :videoTime="videoTime"
      :aiWorkFlowCreated="aiWorkFlowCreated"
    ></ai-workflow-charge-modal>
    <template v-if="hasError">
      <v-alert
        v-if="!permanentError"
        v-model="hasError"
        type="warning"
        density="compact"
        icon="mdi-alert-circle"
      >
        {{ $t('message.ai.queueError') }}
        <v-spacer></v-spacer>
        <BaseBtn
          class="mt-4"
          type="tertiary"
          @click="generateAiWorkFlow('tryAgain')"
          :loading="tryAgainLoading"
          >{{ $t('message.pages.webhooks.tryAgain') }}</BaseBtn
        >
      </v-alert>
      <v-alert v-else v-model="hasError" type="error">
        {{ $t('message.ai.permanentError') }}
      </v-alert>
    </template>
  </v-col>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import aiworkflowApi from '@/services/aiworkflowApi'
import creditsInfo from '@/components/CreditsInfo.vue'
import BaseBtn from '@/components/BaseBtn.vue'
import aiWorkflowChargeModal from './AiWorkFlowChargeModal.vue'
import formatTimeMixin from '@/utils/formatTime.mixins.js'
export default {
  name: 'VideoPlayerOptionsAI',
  components: { creditsInfo, aiWorkflowChargeModal, BaseBtn },
  props: {
    isBeta: {
      required: true,
    },
    handleSelectOption: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    hiddeActiveBtn: true,
    isModalOpen: false,
    creditsBalance: 0,
    creditsPerMin: 1, // was 3
    aiWorkFlowCreditsBalance: {
      aiWorkFlowPrice: 0,
      remainingCredits: 0,
      creditsBalance: 0,
    },
    videoTime: '',
    aiWorkFlowCreated: false,
    isLoading: {
      questions: false,
      abstract: false,
      mindmap: false,
    },
    loopCheck: 0,
    shouldRestartLoop: false,
    isAiWorkFlowLoaded: false,
    fromLang: 'auto',
    isCompleted: false,
    hasError: false,
    originalLang: false,
    queueIds: null,
    tryAgainLoading: false,
    permanentError: false,
    tryAgainAttempts: 0,
  }),
  mixins: [formatTimeMixin],

  computed: {
    ...mapState({
      video: (state) => state.video.video,
      hasStatus: (state) => state.video.aiWorkFlow?.status,
      hasData: (state) => state.video.aiWorkFlow?.data,
    }),
  },
  mounted() {
    this.fetchAiWorkFlowData()
    this.isActivationCompleted()

    this.$root.$on('closeAiWorkFlowModal', () => (this.isModalOpen = false))

    this.$root.$on('balance', (balance) => {
      this.aiWorkFlowCreditsBalance.creditsBalance = balance
      this.aiWorkFlowPriceCalc()
      this.remainingCreditsCalc()
    })
    this.$root.$on('generateAiWorkFlow', () => {
      this.generateAiWorkFlow()
    })
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    this.$root.$off('generateAiWorkFlow')
    this.$root.$off('closeAiWorkFlowModal')
    clearInterval(this.updateInterval)
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    )
  },
  watch: {
    isLoading: {
      handler() {
        this.fetchAiWorkFlowData()
        this.$root.$emit('fetchSubtitles')
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations('video', [
      'UPDATE_AI_WORKFLOW_DATA',
      'UPDATE_AI_WORKFLOW_STATUS',
    ]),
    ...mapActions('video', ['aiWorkFlowStatus', 'handleFetchAiWorkFlowData']),
    async isActivationCompleted() {
      const status = await this.fetchStatus()
      if (!status) {
        this.hiddeActiveBtn = false
        this.aiWorkFlowCreated = false
        return
      }
      const statusValues = Object.values(status)

      const isCompleted = this.checkIfAllFinished(
        ['QUESTIONS', 'MINDMAP', 'ABSTRACT'],
        status
      )
      const isError = statusValues.some((value) =>
        ['ERROR', 'SKIPPED'].includes(value.status)
      )
      const isQueueing = statusValues.some((value) =>
        ['QUEUE', 'RUNNING'].includes(value.status)
      )

      let is24hQueue = false

      if (isQueueing) {
        is24hQueue = this.is24hQueueing(status)
      }
      if (is24hQueue) {
        this.hasError = true
        this.permanentError = true
        return
      }

      if (isCompleted) {
        this.aiWorkFlowCreated = true
        this.isAiWorkFlowLoaded = true
      } else if (isError && !isQueueing) {
        this.hasError = true
      } else {
        this.shouldRestartLoop = true
        this.fetchAiWorkFlowStatus()
      }
    },
    is24hQueueing(status) {
      const now = Date.now()
      const time24h = 24 * 3600 * 1000

      for (const { status: itemStatus, created_at: createdAt } of status) {
        if (['QUEUE', 'RUNNING'].includes(itemStatus)) {
          const creationTimestamp = Date.parse(createdAt)
          if (!isNaN(creationTimestamp)) {
            const age = now - creationTimestamp
            if (age > time24h) {
              return true
            }
          }
        }
      }

      return false
    },
    async fetchStatus() {
      try {
        const status = await this.aiWorkFlowStatus(this.video.id)
        return status
      } catch (error) {
        console.error('Error fetching AI Workflow status:', error)
        return false
      }
    },

    async generateAiWorkFlow(tryAgain) {
      if (tryAgain) this.tryAgainAttempts++

      this.tryAgainLoading = true
      try {
        await this.checkIfHasTrancription()

        const { data } = await aiworkflowApi.createAiWorkFlow({
          fromLang: this.fromLang,
          videoId: this.video.id,
        })
        this.queueIds = Object.values(data).map((obj) => obj.id)

        this.hasError = false
        this.$root.$emit('reloadBalance')
        this.aiWorkFlowCreated = true
        this.hiddeActiveBtn = true
        this.shouldRestartLoop = true
        this.fetchAiWorkFlowStatus()
      } catch (error) {
        this.aiWorkFlowCreated = false
        this.hiddeActiveBtn = false
        console.log(error)
        this.tryAgainLoading = false
      }
    },
    async fetchAiWorkFlowStatus() {
      try {
        let status = await this.aiWorkFlowStatus(this.video.id)
        if (status) {
          this.handleLoading(status)
        } else {
          this.aiWorkFlowCreated = false
        }
      } catch (error) {
        console.error('Error fetching AI Workflow status:', error)
        this.hasError = true
        this.tryAgainLoading = false
      }
    },
    handleLoading(status) {
      let statusFromThisGeneration
      if (this.queueIds) {
        statusFromThisGeneration = status.filter((obj) =>
          this.queueIds.includes(obj.id)
        )
      } else {
        statusFromThisGeneration = status
      }

      const isCompleted = this.checkIfAllFinished(
        ['QUESTIONS', 'MINDMAP', 'ABSTRACT'],
        statusFromThisGeneration
      )
      const isQueueing = statusFromThisGeneration.some((value) =>
        ['QUEUE', 'RUNNING'].includes(value.status)
      )
      let is24hQueue = false
      if (isQueueing) {
        is24hQueue = this.is24hQueueing(status)
      }
      if (is24hQueue) {
        this.hasError = true
        this.permanentError = true
        return
      }

      statusFromThisGeneration.forEach((obj) => {
        const typeLower = obj.type.toLowerCase()
        const isFinished = obj.status === 'FINISHED'
        const isError = obj.status === 'ERROR' || obj.status === 'SKIPPED'

        this.isLoading[typeLower] = !isFinished

        if (isError && !isQueueing && !isCompleted) {
          this.hasError = true
          clearInterval(this.updateInterval)
          this.aiWorkFlowCreated = false
          this.tryAgainLoading = false
          if (this.tryAgainAttempts >= 1) this.permanentError = true
        } else {
          this.aiWorkFlowCreated = true
        }
      })

      if (
        status.some((obj) => obj.status !== 'FINISHED') &&
        this.loopCheck < 1
      ) {
        this.loopCheck++
        this.startUpdateLoop()
      }

      this.isAiWorkFlowLoaded = !Object.values(this.isLoading).includes(true)
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible' && this.shouldRestartLoop) {
        this.fetchAiWorkFlowStatus()
        this.startUpdateLoop()
      } else if (document.visibilityState === 'hidden') {
        clearInterval(this.updateInterval)
        this.updateInterval = null
      }
    },
    startUpdateLoop() {
      if (this.updateInterval) {
        clearInterval(this.updateInterval)
      }

      this.updateInterval = setInterval(async () => {
        if (!this.isAiWorkFlowLoaded) {
          await this.fetchAiWorkFlowStatus()
        } else {
          clearInterval(this.updateInterval)
          this.updateInterval = null
          this.loopCheck = 0
          this.shouldRestartLoop = false
        }
      }, 10000)
    },

    async fetchAiWorkFlowData() {
      let { pullzone_name, video_external_id } = this.video
      try {
        const ret = await this.handleFetchAiWorkFlowData({
          pullzone_name,
          video_external_id,
        })
        return ret
      } catch (error) {
        console.log(error)
      }
    },
    openAiWorkFlowChargeModal() {
      this.checkOriginalLang()
      this.isModalOpen = true
    },
    aiWorkFlowPriceCalc() {
      this.videoTime = this.formatTime(this.video.length)
      let minutes = Math.floor(this.video.length / 60)

      let remainingSeconds = this.video.length % 60
      if (minutes === 0) {
        this.aiWorkFlowCreditsBalance.aiWorkFlowPrice = this.creditsPerMin
      } else {
        this.aiWorkFlowCreditsBalance.aiWorkFlowPrice =
          minutes * this.creditsPerMin
        if (remainingSeconds > 0) {
          this.aiWorkFlowCreditsBalance.aiWorkFlowPrice += this.creditsPerMin
        }
      }
    },
    remainingCreditsCalc() {
      const remainingCredits =
        Number(this.aiWorkFlowCreditsBalance.creditsBalance) -
        Number(this.aiWorkFlowCreditsBalance.aiWorkFlowPrice)

      this.aiWorkFlowCreditsBalance.remainingCredits = remainingCredits
    },
    checkOriginalLang() {
      this.originalLang = this.video.original_lang
      if (this.originalLang) {
        this.fromLang = this.originalLang
      }
    },
    checkIfAllFinished(types, statusArray) {
      return types.every((type) =>
        statusArray.some(
          (item) => item.type === type && item.status === 'FINISHED'
        )
      )
    },

    async checkIfHasTrancription() {
      const id = this.video.id
      const { subtitles } = await window.db.videos.where({ id: id }).first()
      if (subtitles?.length) {
        this.fromLang = subtitles[0]
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.video-player-options {
  .btn {
    justify-content: space-between;
    text-transform: unset;
  }
}

.optionsText {
  font-weight: 400;
  margin: 0 0 0 5px !important;
  letter-spacing: normal;
  padding: 2px 0;
}

.container-list-icon {
  max-width: 24px;
  max-height: 24px;
}

.newSectionStyle {
  background-color: #ebedff;
  color: var(--v-primary-base);
  font-weight: 500;
  text-transform: uppercase;
  width: 68px;
  display: flex;
  border-radius: 24px;
}
.newSectionStyle span {
  margin: 0 auto;
}

.active-btn {
  width: 64px;
  height: 30px !important;
  font-size: 14px;
  text-transform: none;
}
</style>
